export default __webpack_public_path__ + "assets/zisla-logo-1.fef355eb.png";